import styled from 'styled-components';

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  color: #1b1b1b;
`;